import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { Lotus } from "./Lotus";
import { BRAND, whatsappLink } from "../../data";

const HERO_BG =
  "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden grain"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Royale Thai therapeutic massage"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#151c0f]/80 via-[#151c0f]/70 to-[#151c0f]" />
        <div className="absolute inset-0 bg-[#151c0f]/40" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 text-center px-6 max-w-4xl"
      >
        <Lotus className="w-16 h-12 mx-auto text-[#b89d62] float-slow" />
        <p className="eyebrow mt-6 mb-4">{BRAND.location} · Thai & Therapeutic</p>
        <h1 className="font-serif-display font-light text-[#faf9f6] text-6xl sm:text-7xl lg:text-8xl tracking-[0.18em] leading-none">
          ROYALE
        </h1>
        <div className="flex items-center justify-center gap-4 mt-6">
          <span className="w-12 h-px bg-[#b89d62]/60" />
          <p className="font-serif-display italic text-[#c9d3ca] text-lg sm:text-xl tracking-wide">
            {BRAND.subtitle}
          </p>
          <span className="w-12 h-px bg-[#b89d62]/60" />
        </div>
        <p className="mt-8 text-[#c9d3ca] text-sm sm:text-base font-light max-w-xl mx-auto leading-relaxed">
          {BRAND.tagline}. Escape into a sanctuary of ancient Thai healing,
          warm oils and quiet luxury in the heart of Barcelona.
        </p>

        <div className="mt-11 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            data-testid="hero-whatsapp-cta"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#b89d62] hover:bg-[#d4af37] text-[#151c0f] transition-colors duration-400 px-9 py-4 btn-label"
          >
            Book via WhatsApp
          </a>
          <button
            data-testid="hero-services-cta"
            onClick={() =>
              document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })
            }
            className="inline-flex items-center gap-2 border border-[#faf9f6]/40 hover:border-[#b89d62] text-[#faf9f6] hover:text-[#b89d62] transition-all duration-400 px-9 py-4 btn-label"
          >
            View Treatments
          </button>
        </div>
      </motion.div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#b89d62] animate-bounce">
        <ArrowDown size={22} />
      </div>
    </section>
  );
};
